<template>
  <div class="home">
  <div class="video-background video-container">
    <video playsinline autoplay muted loop disablePictureInPicture>
      <source src="@/assets/video/COMPRO 1.mp4" type="video/mp4">
    </video>
    <div class="overlay"></div>
    <nav v-if="isTop" class="navbar sticky-top bg-transparent navbar-expand-lg">
        <div class="container">
            <a class="navbar-brand" href="/">
                <img src="../assets/LOGO_PIU_BnW.png" width="180" height="144">
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div class="row">
                    <div class="col-md-12">
                        <ul class="navbar-nav navbar-auto d-flex justify-content-end align-items-end">
                            <!--<li class="nav-item">
                                <router-link class="nav-link" to="/wbs" >Whistle Blowing System</router-link>
                            </li>-->
                            <li class="nav-item">
                                <router-link class="nav-link" to="/contact" >{{ $t('menuKontak.mainmenu') }}</router-link>
                            </li>
                        </ul>
                    </div>
                    <hr style="color: white;">
                    <div class="col-md-12">
                        <div class="row d-flex justify-content-end">
                            <!-- <div class="col-md-2 d-flex justify-content-start align-items-center">
                                <a class="navbar-brand" href="/">
                                    <img src="../assets/LOGO_PIU_BnW.png" width="120" height="96">
                                </a>
                            </div> -->
                            <div class="col-md-8 me-5 d-flex justify-content-center align-items-center">
                                <ul class="navbar-nav navbar-auto">
                                    <li class="nav-item dropdown">
                                        <router-link class="nav-link dropdown-toggle" to="/media" role="button" data-bs-toggle="dropdown" aria-expanded="false">Profile</router-link>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <router-link class="dropdown-item" to="/sejarah" > {{ $t('menuProfile.submenu1') }}</router-link>
                                            </li>
                                            <!-- <li>
                                                <router-link class="dropdown-item" to="/visimisi" >Visi Misi</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/nilai" >Nilai-Nilai</router-link>
                                            </li> -->
                                            <li>
                                                <router-link class="dropdown-item" to="/manajemen" > {{ $t('menuProfile.submenu2') }}</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/struktur" > {{ $t('menuProfile.submenu3') }}</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/penghargaan" > {{ $t('menuProfile.submenu4') }}</router-link>
                                            </li>
                                        </ul>
                                    </li>
                                    <!-- <li class="nav-item">
                                        <router-link class="nav-link" to="/governance" >Tata Kelola</router-link>
                                    </li> -->

                                    <li class="nav-item dropdown">
                                        <router-link class="nav-link dropdown-toggle" to="/media" role="button" data-bs-toggle="dropdown" aria-expanded="false">{{ $t('menuTatakelola.mainmenu') }}</router-link>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <router-link class="dropdown-item" to="/governance" >{{ $t('menuTatakelola.submenu1') }}</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/audit" >{{ $t('menuTatakelola.submenu2') }}</router-link>
                                            </li>
                                            <!-- <li>
                                                <router-link class="dropdown-item" to="/complaint" >Customer Complaint</router-link>
                                            </li> -->
                                            <!-- <li>
                                                <router-link class="dropdown-item" to="/procurement" >Pengadaan</router-link>
                                            </li> -->
                                            <!-- <li>
                                                <router-link class="dropdown-item" to="/wbs" >Whistle Blowing System</router-link>
                                            </li> -->
                                        </ul>
                                    </li>

                                    <!-- <li class="nav-item">
                                        <router-link class="nav-link" to="/pabrik" >Pabrik</router-link>
                                    </li> -->

                                    <li class="nav-item dropdown">
                                        <router-link class="nav-link dropdown-toggle" to="/media" role="button" data-bs-toggle="dropdown" aria-expanded="false">{{ $t('menuProduklayanan.mainmenu') }}</router-link>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <router-link class="dropdown-item" to="/ggcp" >{{ $t('menuProduklayanan.submenu1') }}</router-link>
                                            </li>
                                            <li class="dropdown-submenu position-relative">
                            <router-link class="dropdown-item dropdown-toggle" to="/ggcp">
                              {{ $t('menuProduklayanan.submenu2') }}
                            </router-link>
                            <ul class="dropdown-menu submenu w-100 position-absolute start-100 top-0 mt-0">
                              <li>
                                <router-link class="dropdown-item" to="/layanan/investasi-energiutilitas-strategis">
                                  Investasi Energi & Utilitas Strategis
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/layanan/operasi-pemeliharaan">
                                  Operasi & Pemeliharaan
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/layanan/perdagangan-eenrgi-primergas-industri">
                                  Perdagangan Energi Primer
                                </router-link>
                              </li>
                                <li>
                                <router-link class="dropdown-item" to="/layanan/kemitraan-prengembangan-proyek">
                                  Kemitraan Pengembangan Proyek
                                </router-link>
                              </li>
                                 <li>
                                <router-link class="dropdown-item" to="/layanan/portofolio-energi-terbarukan">
                                  Layanan Portofolio Energi Terbarukan
                                </router-link>
                              </li>
                            </ul>
                          </li>
                                             <li>
                                                <router-link class="dropdown-item" to="/kdm" >{{ $t('menuProduklayanan.submenu3') }}</router-link>
                                            </li>
                                        </ul>
                                    </li>
                                    
                                    <!-- <li class="nav-item">
                                        <router-link class="nav-link" to="/pengadaan" >Pengadaan</router-link>
                                    </li> -->
                                    
                                    <!-- <li class="nav-item dropdown">
                                        <router-link class="nav-link dropdown-toggle" to="/media" role="button" data-bs-toggle="dropdown" aria-expanded="false">Publikasi</router-link>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <router-link class="dropdown-item" to="/galeri" >CSR</router-link>
                                            </li>
                                            
                                            <li>
                                                <router-link class="dropdown-item" to="/laporan" >Laporan</router-link>
                                            </li>
                                        </ul>
                                    </li> -->

                                    <li class="nav-item dropdown">
                                        <router-link class="nav-link dropdown-toggle" to="/laporan" role="button" data-bs-toggle="dropdown" aria-expanded="false">{{ $t('menuLaporan.mainmenu') }}</router-link>
                                        <ul class="dropdown-menu">
                                            <!-- <li>
                                                <router-link class="dropdown-item" to="/laporan" >Laporan Tahunan</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/laporan" >Laporan Keuangan</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/laporan" >Laporan Keberlanjutan</router-link>
                                            </li> -->
                                            <li>
                                                <router-link class="dropdown-item" to="/laptah">{{ $t('menuLaporan.submenu1') }}</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/lapkeu">{{ $t('menuLaporan.submenu2') }}</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/lapkeb">{{ $t('menuLaporan.submenu3') }}</router-link>
                                            </li>

                                        </ul>
                                    </li>

                                    <!-- <li class="nav-item">
                                        <router-link class="nav-link" to="/berita" >Berita</router-link>
                                    </li> -->
                                    <li class="nav-item dropdown">
                                        <router-link class="nav-link dropdown-toggle" to="/berita" role="button" data-bs-toggle="dropdown" aria-expanded="false">{{ $t('menuBerita.mainmenu') }}</router-link>
                                        <ul class="dropdown-menu">
                                             <li class="dropdown-submenu position-relative">
                            <router-link class="dropdown-item dropdown-toggle" to="#">
                              {{ $t('menuBerita.submenu1') }}
                            </router-link>
                            <ul class="dropdown-menu submenu w-100 position-absolute start-100 top-0 mt-0">
                              <li>
                                <router-link class="dropdown-item" to="/artikel/2025">
                                  2025
                                </router-link>
                              </li>
                                <li>
                                <router-link class="dropdown-item" to="/artikel/2024">
                                 2024
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/artikel/2023">
                                 2023
                                </router-link>
                              </li>
                                <li>
                                <router-link class="dropdown-item" to="/artikel/2022">
                                 2022
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/artikel/2021">
                                 2021
                                </router-link>
                              </li>
                              <li>
                                    <router-link class="dropdown-item" to="/artikel/2020">
                                 2020
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/artikel/2019">
                                 2019
                                </router-link>
                              </li>
                                
                            </ul>
                          </li>
                                            <li class="dropdown-submenu position-relative">
                            <router-link class="dropdown-item dropdown-toggle" to="#">
                              {{ $t('menuBerita.submenu2') }}
                            </router-link>
                            <ul class="dropdown-menu submenu w-100 position-absolute start-100 top-0 mt-0">
                               <li>
                                <router-link class="dropdown-item"  to="/pers/2025">
                                  2025
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item"  to="/pers/2024">
                                  2024
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/pers/2023">
                                  2023
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/pers/2022">
                                 2022
                                </router-link>
                              </li>
                                <li>
                                <router-link class="dropdown-item" to="/pers/2021">
                                 2021
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/pers/2020">
                                 2020
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/pers/2019">
                                 2019
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/pers/2016">
                                 2016
                                </router-link>
                              </li>
                                
                            </ul>
                          </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/buzz" >{{ $t('menuBerita.submenu3') }}</router-link>
                                            </li>
                                        </ul>
                                    </li>

                                    <!-- <li class="nav-item dropdown">
                                        <router-link class="nav-link dropdown-toggle" to="/pelaporan" role="button" data-bs-toggle="dropdown" aria-expanded="false">Pelaporan</router-link>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <router-link class="dropdown-item" to="/complaint" >Customer Complaint</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/wbs" >Whistle Blowing System (WBS)</router-link>
                                            </li>
                                        </ul>
                                    </li> -->
                                      <!--
                                    <li class="nav-item">
                                        <router-link class="nav-link" to="/pengadaan" >Pengadaan</router-link>
                                    </li>-->

                                   <!-- <li class="nav-item">
                                        <router-link class="nav-link" to="/galeri" >CSR</router-link>
                                    </li>-->
                                    <li class="nav-item">
                                        <router-link class="nav-link" to="/keberlanjutan" >{{ $t('menuKeberlanjutan.mainmenu') }}</router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-3 d-flex justify-content-end align-items-center">
                                <SiteSearch variant="dark" placeholder="Search news" />
                            </div>
                        </div>
                        <!-- <hr style="color: white;"> -->
                        <!-- <ul class="navbar-nav navbar-auto me-auto d-flex justify-content-center align-items-center">
                            <li class="nav-item dropdown me-2">
                                <router-link class="nav-link dropdown-toggle" to="/media" role="button" data-bs-toggle="dropdown" aria-expanded="false">Profile</router-link>
                                <ul class="dropdown-menu">
                                    <li>
                                        <router-link class="dropdown-item" to="/sejarah" >Sejarah</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/visimisi" >Visi Misi</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/nilai" >Nilai-Nilai</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/manajemen" >Manajemen</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/struktur" >Struktur</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/penghargaan" >Penghargaan</router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item dropdown me-2">
                                <router-link class="nav-link dropdown-toggle" to="/media" role="button" data-bs-toggle="dropdown" aria-expanded="false">Tata Kelola</router-link>
                                <ul class="dropdown-menu">
                                    <li>
                                        <router-link class="dropdown-item" to="/governance" >Governance</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/audit" >Audit Charter</router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item dropdown me-2">
                                <router-link class="nav-link dropdown-toggle" to="/media" role="button" data-bs-toggle="dropdown" aria-expanded="false">Produk & Layanan</router-link>
                                <ul class="dropdown-menu">
                                    <li>
                                        <router-link class="dropdown-item" to="/ggcp" >Produk</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/kdm" >Anak Perusahaan</router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item dropdown me-2">
                                <router-link class="nav-link dropdown-toggle" to="/laporan" role="button" data-bs-toggle="dropdown" aria-expanded="false">Laporan</router-link>
                                <ul class="dropdown-menu">
                                    <li>
                                        <router-link class="dropdown-item" to="/laptah">Laporan Tahunan</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/lapkeu">Laporan Keuangan</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/lapkeb">Laporan Keberlanjutan</router-link>
                                    </li>

                                </ul>
                            </li>

                            <li class="nav-item dropdown me-2">
                                <router-link class="nav-link dropdown-toggle" to="/berita" role="button" data-bs-toggle="dropdown" aria-expanded="false">Berita</router-link>
                                <ul class="dropdown-menu">
                                    <li>
                                        <router-link class="dropdown-item" to="/artikel" >Artikel</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/pers" >Siaran Pers</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/buzz" >Bulletin BUZZ</router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item me-2">
                                <router-link class="nav-link" to="/pengadaan" >Pengadaan</router-link>
                            </li>

                            <li class="nav-item">
                                <router-link class="nav-link" to="/galeri" >CSR</router-link>
                            </li>

                            <li class="nav-item ms-5 d-flex justify-content-end">
                                <form class="d-flex" role="search" @submit.prevent="search">
                                    <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search" v-model="searchQuery">
                                    <button class="btn btn-outline-light" type="submit">Search</button>
                                </form>
                            </li>
                        </ul> -->
                    </div>
                </div>
            </div>
        </div>
    </nav>
    <NavBar v-else-if="!isTop" class="fixed-top"/>
    <div class="hero-copy">
      <div class="overlay-text">
        <p><b>One Stop Utility Provider</b></p>
      </div>
    </div>
  </div>
    <CompanyPillars/>
    <BusinessProfile/>
    <NewsCarousal/>
    <FooterSection/>
</div>
</template>

<script>
// @ is an alias to /src
// import ItemCard from '@/components/ItemCard.vue'
// import VideoCaraousal from '@/components/VideoCaraousal.vue'
// import PillarTest from '@/components/PillarTest.vue'
import NavBar from '@/components/NavBar.vue'
import CompanyPillars from '@/components/CompanyPillars.vue'
// import FlashInfo from '@/components/FlashInfo.vue'
// import FlashNews from '@/components/FlashNews.vue'
import FooterSection from '@/components/FooterSection.vue'
import NewsCarousal from '@/components/NewsCarousal.vue'
// import NewsCarousal2 from '@/components/NewsCarousal2.vue'
// import ItemCardTester from '@/components/ItemCardTester.vue'
import BusinessProfile from '@/components/BusinessProfile.vue'
import SiteSearch from '@/components/SiteSearch.vue'

export default {
  name: 'HomeView',
  components: {
    NavBar,
    // VideoCaraousal,
    // PillarTest,
    // ItemCard,
    // FlashInfo,
    // FlashNews,
    FooterSection,
    NewsCarousal,
    // NewsCarousal2,
    // ItemCardTester
    BusinessProfile,
    SiteSearch,
    CompanyPillars
  },
  data() {
    return {
      isTop: true,
    };
  },
  methods: {
    checkScroll() {
      this.isTop = window.scrollY === 0;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.checkScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.checkScroll);
  }
}
</script>
<style scoped>
.fixed-top {
  position: fixed;
  top: 0;
  width: 100%;
}
.nav-link {
    color: #ffffff !important;
    font-weight: bold;
}
.nav-link:hover{
    color: #ffffff !important
}
.dropdown-item {
  transition: background-color 0.3s ease;
}
.dropdown-item:hover {
  background-color: #0d6efd;
  color: #fff;
  cursor: pointer;
}
.video-container {
  position: relative;
  width: 100%;
  height: 100vh; /* This makes the container take up the full height of the viewport */
  overflow: hidden;
}
.video-container video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.video-background {
  position: relative;
  overflow: hidden;
}

.video-background video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background:
    linear-gradient(
      to bottom,
      rgba(4, 10, 18, 0.7) 0%,
      rgba(4, 10, 18, 0.52) 42%,
      rgba(4, 10, 18, 0.28) 74%,
      rgba(4, 10, 18, 0.08) 100%
    );
}

.video-background > .navbar {
  position: relative;
  z-index: 4;
}

.hero-copy {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding: clamp(112px, 10vw, 148px) clamp(20px, 6vw, 72px) clamp(72px, 10vw, 120px);
  pointer-events: none;
}

.overlay-text {
  width: min(100%, 760px);
  margin: 0;
  text-align: left;
  color: white;
  font-size: clamp(2.85rem, 4.8vw, 3.7rem);
  font-weight: 800;
  line-height: 1.08;
  letter-spacing: -0.045em;
  text-wrap: balance;
}
.content {
  position: relative;
  z-index: 1;
}
.dropdown-item:hover {
  background-color: #0d6efd;
  color: #fff;
  cursor: pointer;
}
.dropdown-submenu:hover > .submenu {
  display: block;
}
.submenu {
  display: none;
  left: 100%;
  top: 0;
  margin-top: -1px;
}
.dropdown-submenu > .dropdown-toggle::after {
  content: "▶";
  float: right;
  margin-left: 5px;
  font-size: 0.7em;
}



@media (max-width: 768px) {
  .hero-copy {
    padding: 104px 20px 56px;
  }

  .overlay-text {
    font-size: 2.15rem;
  }
}


@media (max-width: 480px) {
  .video-container {
    position: relative;
    width: 100%;
    height: 100vh; /* This makes the container take up the full height of the viewport */
    overflow: hidden;
  }

  .hero-copy {
    padding: 92px 16px 44px;
  }

  .overlay-text {
    font-size: 1.7rem;
    line-height: 1.12;
  }
}

@media (min-width: 992px) {
    .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute;
        width: 320px;
    }
}

</style>

<style>

/* magic wizard 26 aug 2025*/
@media (max-width: 480px) {
.row.gx-0.d-flex.justify-content-center.ps-5.pe-5 {
   padding-left: unset!important;
   padding-right:unset!important;
}

.container.p-5 {
 padding-left: 14px!important;
 padding-right: 14px!important;
}
.row.mt-2.mb-4.d-flex.justify-content-center {
    display: inline !important;
}
.col-md-3.col-6.mb-3, .col-md-2.col-6.mb-3 {
    width: 100%!important;
}
button.navbar-toggler {
    background-color: white!important;
}
a.nav-link.dropdown-toggle, .nav-link[data-v-9ea40744] {
    color: #000000!important;
}
.navbar-collapse {
  background-color:white!important;
}

ul.navbar-nav.navbar-auto.d-flex.justify-content-end.align-items-end {
    display: inline-block !important;
    padding-left: 20px;
}

form.d-flex {
    display: none !important;
}
}
</style>
